import axios from "axios";
import { getXAuthToken } from "../Authentication/Auth";
import { SwitchLoader } from "./AxiosConfiguration";
import { ErrorManagement } from "./ErrorManagement";
import { StartLoader, StopLoader } from "./Loader";

let loader = "COMMON";
let loaderText = "";

const Instance = axios.create({
  baseURL: process.env.REACT_APP_NODE_BASE_URL,
});

Instance.interceptors.request.use(
  (config) => {
    StartLoader(loader, loaderText);
    // debugger;
    config.headers["x-access-token"] = getXAuthToken().xAuthToken;
    config.headers["content-type"] = "application/json";
    config.headers["From"] = "web";

    // debugger;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

Instance.interceptors.response.use(
  (response) => {
    // StopLoader(loader);
    // debugger;
    return response.data;
  },
  (error) => {
    // StopLoader(loader);
    // debugger;
    ErrorManagement(error);
    return Promise.reject(error);
  }
);

export default Instance;
